import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import AuthStore from '../../stores/AuthStore'
import AuthActions from '../../actions/AuthActions'
import Sidebar from '../../components/Sidebar'
import { Metrics, Colors } from '../../Themes'
import Pangea from '../../svg-icons/Pangea'

const Container = styled.div`
  max-width: 100vw;
  overflow-x: scroll;
`

const ScrollableContainer = styled.div`
  min-width: ${Metrics.components.adminScreensMinWidth};

  & > * {
    float: left;
  }
`

const AdminScreenContent = styled.div`
  height: 100vh;
  width: calc(100% - ${Metrics.components.sidebar});
  left: ${Metrics.components.sidebar};
  background: ${Colors.lightGrey};
  top: 0;

  & > div {
    height: 100%;
  }
`

const CustomLogo = styled(Pangea)`
  width: ${Metrics.components.adminLogoSize};
  height: ${Metrics.components.adminLogoSize};
`

class AdminPublic extends Component {
  constructor (props) {
    super(props)
    this.state = { items: [], currentItem: '' }
    this.onChange = this.onChange.bind(this)
  }

  getInitialState () {
    return AuthStore.getState()
  }

  static getStores () {
    return [ AuthStore ]
  }

  static getPropsFromStores () {
    let authState = AuthStore.getState()
    return {
      admin: authState.admin
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (this.props.admin && !nextProps.admin) {
      this.props.router.replace('/landing')
    }
  }

  componentDidMount () {
    AuthStore.listen(this.onChange)
  }

  componentWillUnmount () {
    AuthStore.unlisten(this.onChange)
  }

  onChange (state) {
    this.setState(state)
  }

  render () {
    const { children, admin, router } = this.props
    const dropdownLinks = [
      {
        label: 'Profile',
        onClick: () => router.replace(`/admin/admins/${admin.id}`)
      },
      { label: 'Log Out', onClick: () => AuthActions.logoutAdmin() }
    ]
    return (
      <Container>
        <ScrollableContainer>
          <Sidebar
            links={[
              { to: '/admin/properties', label: 'Properties' },
              { to: '/admin/users', label: 'Users' },
              { to: '/admin/requests', label: 'Requests' },
              {
                id: 'locations',
                label: 'Locations',
                to: '/admin/locations/',
                sublinks: [
                  { to: '/admin/locations/cities', label: 'Cities' },
                  { to: '/admin/locations/countries', label: 'Countries' },
                  { to: '/admin/locations/continents', label: 'Continents' }
                ]
              },
              { to: '/admin/categories', label: 'Categories' },
              { to: '/admin/admins', label: 'Admins' }
            ]}
            logo={<CustomLogo />}
          />
          <AdminScreenContent>
            {children &&
              React.cloneElement(children, {
                admin,
                dropdownLinks
              })}
          </AdminScreenContent>
        </ScrollableContainer>
      </Container>
    )
  }
}

AdminPublic.propTypes = {
  children: PropTypes.node,
  admin: PropTypes.object,
  router: PropTypes.object
}

export default AdminPublic



// WEBPACK FOOTER //
// ./src/pages/AdminPublic/index.js